import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Classroom360Service } from '../../classroom360/classroom360.service';
import { Portal } from '../portal.model';
import { LoaderService } from '../spinner/loader-service.component';
import { StudentService } from '../student/student.service';
import { PortalMenuItem, PortalMenuPreferences } from '../user-preferences/portal-menu-preferences.model';
import { UserPreferencesService } from '../user-preferences/user-preferences.service';
import { UserService } from '../user/user.service';

@Component({
  selector: 'child-menu',
  templateUrl: './child-menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class ChildMenuComponent implements OnInit {

  @Input() portals: Portal[];
  @Input() portalMenuPreferences: PortalMenuPreferences;
  @Input() parentId: number;
  @Input() favoritesFilter: boolean;
  @Input() favoritesCheckbox: boolean;
  @Input() favoritesDefaults: boolean;
  @Input() searchValue = '';
  @Output() menuClickEvent = new EventEmitter<any>();
  @Output() portalCheckboxClickEvent = new EventEmitter<any>();
  clonedPortals: Portal[] = [];
  searchString = '';
  userType = 0;

  constructor(
    private userService: UserService,
    private studentService: StudentService,
    private classroom360Service: Classroom360Service,
    private userPreferencesService: UserPreferencesService,
    private loaderService: LoaderService,
  ) {
    this.userType = this.userService.userType;
  }

  ngOnInit() {
    this.classroom360Service.observableStaffAssignedPortalsStream$.subscribe(_ => {
      this.userType = this.userService.userType;

      if (this.parentId == 0) {
        setTimeout(() => {
          this.searchClick();
        }, 0);
      }
    });
  }

  menuPortalClick(portal: Portal) {
    if (portal != null && portal.Disabled == false) {
      this.menuClickEvent.emit(portal);
    }
  }

  childMenuClick(portal: Portal) {
    if (portal != null && portal.Disabled == false) {
      this.menuClickEvent.emit(portal);
    }
  }

  portalCheckboxClick(portal: Portal) {
    this.portalCheckboxClickEvent.emit(portal);
  }

  childPortalCheckboxClick(portal: Portal) {
    this.portalCheckboxClickEvent.emit(portal);
  }

  savePreferences(portal: Portal) {
    portal.Expanded = portal.Expanded == 1 ? 0 : 1;
    if (this.searchString == '') {
      // POST: saves the portal preferences
      const studentId = this.userType == 2 && this.studentService.selectedStudent != null && this.studentService.selectedStudent.Id != null ? this.studentService.selectedStudent.Id : 0;
      const portalMenuPreference = this.portalMenuPreferences.PortalMenus.filter(o => o.Id == portal.Id || ((o.Id == null || o.Id == 0) && o.GroupName == portal.GroupName))[0];
      if (portalMenuPreference != null) {
        portalMenuPreference.Expanded = portal.Expanded;
      }
      else {
        const portalMenu: PortalMenuItem = {
          GroupName: portal.GroupName,
          Expanded: portal.Expanded,
          GroupIcon: portal.GroupIcon,
          Id: portal.Id
        };
        this.portalMenuPreferences.PortalMenus.push(portalMenu);
      }

      const xmlStream: string[] = [];
      xmlStream.push(JSON.stringify(this.portalMenuPreferences));
      this.userPreferencesService.saveUserPreferences(studentId, '/OneSISPortalMenuPreferences', xmlStream, 0, '').subscribe();
      this.loaderService.isLoading.next(false);
    }
  }

  showParentGroup(portal: Portal): boolean {
    if (this.favoritesFilter) {
      if (portal.ParentId == 0 && portal.PortalDescription != '' && portal.Selected == true) {
        return true;
      }
      else if (this.portals.filter(o => o.ParentId == portal.Id && o.Selected == true).length > 0) {
        return true;
      }
      else {
        this.portals.filter(o => o.ParentId == portal.Id && o.PortalDescription == '').forEach(obj => {
          this.showParentGroup(obj);
        });
      }
    }
    return false;
  }

  searchClick() {
    if (this.searchString != null && this.searchString != '') {
      if (this.clonedPortals.length > 0) {
        this.portals = JSON.parse(JSON.stringify(this.clonedPortals));
      }
      this.searchValue = this.searchString;
      this.clonedPortals = JSON.parse(JSON.stringify(this.portals));

      const filteredPortals = this.portals.filter(o => o.PortalName.toLowerCase().indexOf(this.searchValue.toLowerCase()) >= 0);
      filteredPortals.filter(o => o.PortalDescription == '').forEach(obj => {
        obj.Expanded = 1;
        this.addChildRecord(filteredPortals, obj.Id);
      });
      filteredPortals.filter(o => o.ParentId > 0).forEach(obj => {
        this.addParentRecord(filteredPortals, obj.ParentId);
      });

      this.portals = filteredPortals;
    }
    else {
      this.clearSearchClick();
    }
  }

  clearSearchClick() {
    this.searchString = '';
    this.searchValue = this.searchString;
    if (this.clonedPortals.length > 0) {
      this.portals = JSON.parse(JSON.stringify(this.clonedPortals));
      this.clonedPortals = [];
    }
  }

  addParentRecord(filteredPortals: Portal[], parentId: number) {
    if (filteredPortals.filter(o => o.Id == parentId).length == 0) {
      const portal = this.portals.filter(o => o.Id == parentId)[0];
      if (portal != null) {
        portal.Expanded = 1;
        filteredPortals.push(portal);
        if (portal.ParentId > 0) {
          this.addParentRecord(filteredPortals, portal.ParentId);
        }
      }
    }
  }

  addChildRecord(filteredPortals: Portal[], portalId: number) {
    this.portals.filter(o => o.ParentId == portalId).forEach(obj => {
      if (filteredPortals.filter(o => o.Id == obj.Id).length == 0) {
        const portal = this.portals.filter(o => o.Id == obj.Id)[0];
        if (portal != null) {
          portal.Expanded = 1;
          filteredPortals.push(portal);
          if (portal.PortalDescription == '') {
            this.addChildRecord(filteredPortals, portal.Id);
          }
        }
      }
    });
  }
}
